/**
 * @flow
 * @relayHash ef4944fb5e52745cb1408efe664e4237
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ClubQueryVariables = {||};
export type ClubQueryResponse = {|
  +clubs: ?$ReadOnlyArray<?{|
    +ref_id: string,
    +name: ?string,
    +id: string,
  |}>
|};
export type ClubQuery = {|
  variables: ClubQueryVariables,
  response: ClubQueryResponse,
|};
*/


/*
query ClubQuery {
  clubs {
    ref_id
    name
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "clubs",
    "storageKey": null,
    "args": null,
    "concreteType": "Club",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ref_id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ClubQuery",
  "id": null,
  "text": "query ClubQuery {\n  clubs {\n    ref_id\n    name\n    id\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ClubQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v0
  },
  "operation": {
    "kind": "Operation",
    "name": "ClubQuery",
    "argumentDefinitions": [],
    "selections": v0
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '13be098926c2d0967be4086304b33b62';
module.exports = node;
